export const positiveRouter = [
  {
    path: "/staff-manage/positive/list",
    name: "positive-list",
    meta: { title: "转正管理" },
    component: () => import(/* webpackChunkName: "positive-list" */ "@/views/staff-manage/positive/list/index.vue"),
  },
  {
    path: "/staff-manage/positive/add/:staffId?",
    name: "positive-add",
    hidden: true,
    meta: { title: "新增转正申请", comName: "StaffManagePositiveFormCreate" },
    component: () =>
      import(/* webpackChunkName: "positive-add" */ "@/views/staff-manage/positive/form-create/index.vue"),
  },
  {
    path: "/staff-manage/positive/edit/:id",
    name: "positive-eidt",
    hidden: true,
    meta: { title: "编辑转正申请", comName: "StaffManagePositiveFormCreate" },
    component: () =>
      import(/* webpackChunkName: "positive-edit" */ "@/views/staff-manage/positive/form-create/index.vue"),
  },
  {
    path: "/staff-manage/positive/detail/:id",
    name: "positive-detail",
    hidden: true,
    meta: { title: "转正申请详情" },
    component: () =>
      import(/* webpackChunkName: "positive-detail" */ "@/views/staff-manage/positive/form-detail/index.vue"),
  },
  {
    hidden: true,
    path: "/staff-manage/positive/flowPrint/:id",
    name: "positive-flow-print",
    meta: { title: "打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "project-profile" */ "@/views/staff-manage/positive/flow-print/index.vue"
      ),
  },
]
